module.exports = __webpack_public_path__ + "media/images/lb/912-d0083bf8b0352f2553d43f554df91a41.svg";